const module = { name: 'swig/lib/DateZ', exports: {} }; const exports = module.exports;



import { swig_lib_utils as utils } from 'require-core';



const DateZ = function () {
    const members = {
        default: ['getUTCDate', 'getUTCDay', 'getUTCFullYear', 'getUTCHours', 'getUTCMilliseconds', 'getUTCMinutes', 'getUTCMonth', 'getUTCSeconds', 'toISOString', 'toGMTString', 'toUTCString', 'valueOf', 'getTime'],
        z: ['getDate', 'getDay', 'getFullYear', 'getHours', 'getMilliseconds', 'getMinutes', 'getMonth', 'getSeconds', 'getYear', 'toDateString', 'toLocaleDateString', 'toLocaleTimeString']
    };
    const d = this;
    d.date = d.dateZ = (arguments.length > 1) ? new Date(Date.UTC.apply(Date, arguments) + ((new Date()).getTimezoneOffset() * 60000)) : (arguments.length === 1) ? new Date(new Date(arguments['0'])) : new Date();
    d.timezoneOffset = d.dateZ.getTimezoneOffset();
    utils.each(members.z, (name) => {
        d[name] = function () {
            return d.dateZ[name]();
        };
    });
    utils.each(members.default, (name) => {
        d[name] = function () {
            return d.date[name]();
        };
    });
}
DateZ.prototype = {
    getTimezoneOffset() {
        return this.timezoneOffset;
    },
    setTimezoneOffset(offset) {
        this.timezoneOffset = offset;
        this.dateZ = new Date(this.date.getTime() + this.date.getTimezoneOffset() * 60000 - this.timezoneOffset * 60000);
        return this;
    }
};
module.exports = {
    DateZ
};
export default module.exports;